import l1 from "../../assets/badges/l1.svg";
import l2 from "../../assets/badges/l2.svg";
import l3 from "../../assets/badges/l3.svg";
import l4 from "../../assets/badges/l4.svg";
import l5 from "../../assets/badges/l5.svg";
import l6 from "../../assets/badges/l6.svg";
import l7 from "../../assets/badges/l7.svg";
import l8 from "../../assets/badges/l8.svg";
import l9 from "../../assets/badges/l9.svg";
import l10 from "../../assets/badges/l10.svg";
import l11 from "../../assets/badges/l11.svg";
import l12 from "../../assets/badges/l12.svg";
import s1 from "../../assets/badges/s1.svg";
import s2 from "../../assets/badges/s2.svg";
import s3 from "../../assets/badges/s3.svg";
import s4 from "../../assets/badges/s4.svg";
import s5 from "../../assets/badges/s5.svg";
import s6 from "../../assets/badges/s6.svg";
import s7 from "../../assets/badges/s7.svg";
import s8 from "../../assets/badges/s8.svg";
import s9 from "../../assets/badges/s9.svg";
import s10 from "../../assets/badges/s10.svg";
import s11 from "../../assets/badges/s11.svg";
import s12 from "../../assets/badges/s12.svg";
import s13 from "../../assets/badges/s13.svg";
import s14 from "../../assets/badges/s14.svg";
import s15 from "../../assets/badges/s15.svg";
import s16 from "../../assets/badges/s16.svg";
import s17 from "../../assets/badges/s17.svg";
import s18 from "../../assets/badges/s18.svg";
import s19 from "../../assets/badges/s19.svg";
import s20 from "../../assets/badges/s20.svg";
import s21 from "../../assets/badges/s21.svg";
import s22 from "../../assets/badges/s22.svg";
import s23 from "../../assets/badges/s23.svg";
import s24 from "../../assets/badges/s24.svg";
import s25 from "../../assets/badges/s25.svg";
import s26 from "../../assets/badges/s26.svg";
import s27 from "../../assets/badges/s27.svg";
import s28 from "../../assets/badges/s28.svg";
import s29 from "../../assets/badges/s29.svg";
import s30 from "../../assets/badges/s30.svg";
import s31 from "../../assets/badges/s31.svg";
import s32 from "../../assets/badges/s32.svg";
import s33 from "../../assets/badges/s33.svg";
import s34 from "../../assets/badges/s34.svg";
import s35 from "../../assets/badges/s35.svg";
import s36 from "../../assets/badges/s36.svg";

const Badges = [
  {
    img: l1,
    url: "https://leetcode.com/vsadvdsag/",
  },
  {
    img: l2,
    url: "https://leetcode.com/vsadvdsag/",
  },
  {
    img: l3,
    url: "https://leetcode.com/vsadvdsag/",
  },
  {
    img: l4,
    url: "https://leetcode.com/vsadvdsag/",
  },
  {
    img: l5,
    url: "https://leetcode.com/vsadvdsag/",
  },
  {
    img: l6,
    url: "https://leetcode.com/vsadvdsag/",
  },
  {
    img: l7,
    url: "https://leetcode.com/vsadvdsag/",
  },
  {
    img: l8,
    url: "https://leetcode.com/vsadvdsag/",
  },
  {
    img: l9,
    url: "https://leetcode.com/vsadvdsag/",
  },
  {
    img: l10,
    url: "https://leetcode.com/vsadvdsag/",
  },
  {
    img: l11,
    url: "https://leetcode.com/vsadvdsag/",
  },
  {
    img: l12,
    url: "https://leetcode.com/vsadvdsag/",
  },
  {
    img: s1,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s2,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s3,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s4,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s5,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s6,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s7,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s8,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s9,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s10,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s11,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s12,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s13,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s14,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s15,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s16,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s17,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s18,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s19,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s20,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s21,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s22,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s23,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s24,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s25,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s26,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s27,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s28,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s29,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s30,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s31,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s32,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s33,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s34,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s35,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
  {
    img: s36,
    url: "https://trailblazer.me/id/abhyudaya001",
  },
];

export default Badges;
